import React from "react";
import { getInDataState, getInTarifsState } from "../../Utils/storeHelpers";
import TarifRecapOptions from "./TarifRecapOptions";
import { green } from "../../Utils/styleConstants";

const EReputationRecap = () => {
    const type = getInDataState("offre-e-reputation.type") || "e-reputation-agence";
    const suffix = type.replace("e-reputation-", "");

    const activationFee = getInTarifsState(`activation-fee-e-reputation-${suffix}`);

    const valueDisplay = getInTarifsState(
        type === "e-reputation-agence"
            ? "e-reputation-value-display-agence"
            : "e-reputation-value-display-mandataire"
    );

    const offer = getInTarifsState(`offer-${suffix}-e-reputation`);

    const rows = [
        {
            label: "Sous-Total",
            prices: [
                {
                    value: valueDisplay?.price ?? 0,
                    unit: `HT ${valueDisplay?.priceUnit ?? ""}`,
                },
            ],
        },
        {
            label: "Offre de lancement" ,
            subLabels: ["Frais de mise en service"],
            backgroundColor: green,
            color: "black",
            fontSize: "25px",
            prices: [
                {
                    value: offer?.price ?? 0,
                    color: "white",
                    unit: `HT ${offer?.priceUnit ?? ""}`,
                },
                {
                    value: activationFee?.price ?? 0,
                    color: "white",
                    unit: "HT",
                    small: true,
                },
            ],
        },
    ];

    return <TarifRecapOptions rows={rows} />;
};

export default EReputationRecap;